import InvoiceContainerController from "emun.invoice/inv/inv-container.controller";
import Invoice from "emun.invoice/inv/inv.model";
import DownloadImagesPrompt from "emun.cart/download-cart-images-prompt";

export default class InvoiceDetailsController extends InvoiceContainerController {
  getQueries() {
    const $ctrl = this;
    console.debug("InvoiceDetailsController", $ctrl);
    return {
      query: {
        ...super.getQuery(),
        url: `QueryInvoices.json`,
        fields: null,
        criteria: {
          IncludeProducts: 1,
          Id: $ctrl.invoiceId,
        },
        views: {},
        filters: [],
        disableQueryString: true,
        pageSize: 1,
        offset: 0,
      },
      retailers: {
        url: `QueryRetailers.json`,
        disableQueryString: true,
        pageSize: 1,
        autoLoad: false,
        onLoaded: $ctrl.onRetailersLoaded.bind($ctrl),
      },
      orders: {
        url: `QueryCarts.json`,
        disableQueryString: true,
        pageSize: 1,
        autoLoad: false,
        onLoaded: $ctrl.onOrdersLoaded.bind($ctrl),
      },
      tags: {
        url: `QueryTags.json?op=QueryInvoiceTags`,
        criteria: {
          Shard: "Invoice",
          OrderBy: "Position",
        },
        disableQueryString: true,
        pageSize: 1000,
        autoLoad: false,
        onLoaded: $ctrl.onTagsLoaded.bind($ctrl),
      },
    };
  }

  onInvoicesLoaded(args) {
    const $ctrl = this;
    $ctrl.invoice = new Invoice(args.first, true);
    console.debug("onInvoicesLoaded", $ctrl.invoice);
    $ctrl.tags.filter("PrincipalId", $ctrl.invoice.id);
    $ctrl.retailers.filter("Id", args.first.retailerId);
    $ctrl.orders.filter("Id", args.first.orderNumber);
  }

  onRetailersLoaded(args) {
    const $ctrl = this;
    $ctrl.retailer = args.first;
    console.debug("onRetailersLoaded", args.first);
  }

  onOrdersLoaded(args) {
    const $ctrl = this;
    $ctrl.order = args.first;
    console.debug("onOrdersLoaded", args.first);
  }

  onTagsLoaded(args) {
    const $ctrl = this;
    $ctrl.tags = args.results;
    $ctrl.invoice.tags = $ctrl.tags;
    console.debug("onTagsLoaded", args.results);
  }

  //https://emun1.monday.com/boards/333027351/views/4635648/pulses/833175192?advancedFilters=true&people=person-10628996
  getInvoiceIndex(id) {
    const $ctrl = this;
    return $ctrl.container.query.results.findIndex(
      (r) => r.id === (id || $ctrl.invoice.id)
    );
  }

  canGoNext() {
    const $ctrl = this;
    if (!$ctrl.invoice) return false;
    $ctrl.invoiceIndex = $ctrl.getInvoiceIndex($ctrl.invoice.id);
    return $ctrl.invoiceIndex < $ctrl.container.query.results.length - 1;
  }
  nextInvoice() {
    const $ctrl = this;
    // console.debug("nextInvoice", $ctrl.canGoNext(), $ctrl);
    if ($ctrl.canGoNext()) {
      return $ctrl.selectInvoice(
        $ctrl.container.query.results[$ctrl.invoiceIndex + 1]
      );
    }
  }
  getNextInvoice() {
    const $ctrl = this;
    if ($ctrl.canGoNext()) {
      return $ctrl.container.query.results[$ctrl.invoiceIndex + 1];
    }
  }
  canGoPrev() {
    const $ctrl = this;
    if (!$ctrl.invoice) return false;
    $ctrl.invoiceIndex = $ctrl.getInvoiceIndex($ctrl.invoice.id);
    return $ctrl.invoiceIndex > 0;
  }
  prevInvoice() {
    const $ctrl = this;
    if ($ctrl.canGoPrev()) {
      return $ctrl.selectInvoice(
        $ctrl.container.query.results[$ctrl.invoiceIndex - 1]
      );
    }
  }
  getPrevInvoice() {
    const $ctrl = this;
    if ($ctrl.canGoNext()) {
      return $ctrl.container.query.results[$ctrl.invoiceIndex + 1];
    }
  }
  selectInvoice(invoice) {
    const $ctrl = this;
    // console.debug("selectInvoice", { invoice, $ctrl });
    $ctrl.$state.go(".", { invoiceId: invoice.id });
  }
  downloadImagesPrompt(ext) {
    const $ctrl = this;
    return DownloadImagesPrompt({
      subTitle: $ctrl.invoice.id + " - " + $ctrl.invoice.companyName,
      productIds: $ctrl.invoice.lines.map((m) => m.productId),
      id: $ctrl.invoice.id,
    });
  }
}
